export const pluginId = 'documentation';
